export default __webpack_public_path__ + "static/media/2.08cf8e13.jpeg";